import { RelationshipType } from './consent.model';

export interface ShareInfo {
  shareId: string;
  shareType: 'platform' | 'email' | 'link';
  shareeName: string;
  consentStartDate: Date;
  consentEndDate: Date;
}

export interface Meter {
  meterNumber: string;
  meterType: MeterType;
  fuelType: FuelType; // Added fuelType
  address: string;
  postCode?: string;
  consentStatus: ConsentStatus;
  startDate: Date; // Added start date for consent
  expiryDate: Date;
  numberOfShares?: number; // Number of partners this meter is shared with
  shareeNames?: ShareInfo[]; // Detailed share information including shareId, type, and name
  consentId?: string; // Added to track the consent ID for each meter
  consumption?: number | null;
  relationship?: RelationshipType;
}

export interface MeterPreview {
  meterNumber: string;
  meterType?: MeterType;
  fuelType: FuelType;
  address: string;
}

export enum ConsentStatus {
  ACTIVE = 'Active',
  EXPIRED = 'Expired',
  PENDING = 'Pending',
  REVOKED = 'Revoked',
}

export enum FuelType { // Added FuelType enum
  ELEC = 'Elec',
  GAS = 'Gas'
}

export enum MeterType {
  HALF_HOURLY = 'Half Hourly',
  NON_HALF_HOURLY = 'Non Half Hourly',
  SMART = 'Smart Meter'
}

export interface AddressLineRequest {
    postCode: string;
    fuelType: string;
    customerConsent: string;
    customerName: string;
}

export interface AddressLine {
    addressId: string;
    postCode: string;
    addressAsLine: string;
    numberMPAN: number;
    numberMPRN: number;
}

export interface AddressResponse {
    addressId: string;
    postcode: string;
    address: string;
    hasElectricityMeters: boolean;
    hasGasMeters: boolean;
    relatedData: {
      MPAN?: string[];
      UPRN?: string[];
      XID?: string[];
    };
}

export interface AddressMasterSearchTemplate {
  addressSearchV3: AddressResponse[];
}

export interface AddressLineResponse {
    status: string;
    code: number;
    data: AddressMasterSearchTemplate;
}

export interface MeterDetailsRequest {
    addressId?: string;
    mpan?: string;
    fuelType: string;
    customerConsent: string;
}

export interface MeterDetails {
  meterNo: string;
  fuelType: FuelType;
  meterType: MeterType;
  addressId: string;
  addressAsLine: string;
  currentSupplierName: string;
  consentId?: string; // Added to track the consent ID for each meter
  moveInDate?: string; // Changed to string to match API format,
  postCode: string;
  postTown?: string; // Optional field for post town
}

export interface ElecMeterDetails {
  mpanCore: string;
  meterType: string;
  profileClass: string;
  dataType: string;
  addressId: string;
  addressAsLine: string;
  currentSupplierName: string;
  consumption: number;
  postCode: string;
  postTown: string;
}

export interface GasMeterDetails {
  addressId: string;
  addressAsLine: string;
  MPRN: string;
  meterMechanismCode: string;
  currentSupplierName: string;
  consumption: number;
  keyMeterType: string;
  postCode: string;
  postTown: string;
}

export interface ElecMeterDetailsTemplate {
  elecAdvancedMeterDetails: ElecMeterDetails[];
}

export interface GasMeterDetailsTemplate {
  gasAdvancedMeterDetails: GasMeterDetails[];
}



export interface MeterDetailsResponse {
    status: string;
    code: number;
    data: MeterDetails[];
}


export interface MeterSelection {
  selectedMeter: MeterDetails[];
  addressType: string; // 'address' or 'meterNo'
  meterNoSearch?: {
    meterNo: string;
    fuelType: FuelType;
  };
  addressSearch?: {
    addressId: string;
    postCode: string;
    fuelType: FuelType;
  };
}

export interface SmartMeterConsentStatus {
  meterNo: string;
  org: string;
  consentStatus: 'CONSENT_SIGNED' | 'FAILED' | 'PENDING';
  moveInDate: string;
  consentDate: string | null;
  consentType: string;
  emailAddress: string;
  smartMeterVerifyStatus: 'CONSENT_SIGNED' | 'FAILED' | 'PENDING';
  createdAt: string;
}